/** 各フェーズ定義 */
export const PHASE = {
  START: 'start',
  EXECUTION: 'execution',
  SUCCESS: 'success',
  ADJUSTMENT_NG: 'adjustment_ng',
  ADJUSTMENT_NO: 'adjustment_no',
  FAILED: 'failed',
  ERROR: 'error'
};

/** 現在セッション */
export const SESSION_PROPERTY = {
  DEFAULT: 0,
  NON_DEFAULT: 1
};

/** 軸調整結果 */
export const ADJUSTMENT_STATUS = {
  ADJUSTMENT_OK: 'ok',
  ADJUSTMENT_NG: 'ng',
  ADJUSTMENT_NO: 'no',
  ADJUSTMENT_FAILED: 'failed',
};